import React from 'react';
import styles from './PropertyPremiumFeatures.scss';
import { IProperty } from '../utils/JsonApiRequest';
import useUser from '../stores/useUser';
import PropertyRequest, { IPropertyStatistic } from '../utils/PropertyRequest';
import LoadingIndicator from './LoadingIndicator';
import ButtonRound from './ButtonRound';
import { createModal } from '../utils/CreateModal';
import Config from '../utils/Config';
import LockIcon from '../assets/img/lock.svg';

const buyPremiumRoute = Config.get('buyPremiumRoute');

const ratings = [
    <>
        <p>Könnte klappen</p>
    </>,
    <>
        <p>Da geht was</p>
    </>,
    <>
        <p>Ganz okay</p>
    </>,
    <>
        <p>Du brauchst Glück</p>
    </>,
    <>
        <p>Nicht so gut</p>
    </>,
];

export interface IPropertyPremiumFeaturesProps {
    id: IProperty['drupal_internal__id'];
    uuid: IProperty['id'];
}

const PropertyPremiumFeatures: React.FC<React.PropsWithChildren<IPropertyPremiumFeaturesProps>> = ({ uuid = null, id = null }) => {
    const [user] = useUser();

    const isPremium = user.isPremium;
    const [data, setData] = React.useState<IPropertyStatistic>({
        pageview: null,
        contactRequests: null,
        created: null,
    });

    React.useEffect(() => {
        if (isPremium) {
            PropertyRequest.getStatistic(id).then((stat) => {
                setData(stat);
            });
        }
    }, [user]);

    const activeRating = Math.floor(Math.min(4, data.contactRequests / 5));

    const handleGetPremium = () => {
        if (user.isLoggedIn) {
            location.assign(`/user/${user.uid}/premium`);
        } else {
            createModal.createRegister((currUser) => {
                if (!currUser.is_premium) {
                    location.assign(`/user/${currUser.uid}/premium?destination=${window.location.pathname}`);
                }
            });
        }
    };

    return user.isLoading ? (
        <LoadingIndicator />
    ) : (
        <div className={[styles.propertyPremiumFeatures].join(' ')}>
            {!isPremium ? (
                <div className={styles.featureContainer}>
                    <div className={styles.featureBox}>
                        <p className={styles.text}>Anfragen bisher</p>
                        <a onClick={handleGetPremium} className={styles.premiumText}><LockIcon />Premium</a>
                    </div>
                    <div className={styles.featureBox}>
                        <p className={styles.text}>Meine Chancen</p>
                        <a onClick={handleGetPremium} className={styles.premiumText}><LockIcon />Premium</a>
                    </div>
                    <div className={styles.featureBox}>
                        <p className={styles.text}>Fairer Preis</p>
                        <a onClick={handleGetPremium} className={styles.premiumText}><LockIcon />Premium</a>
                    </div>
                    <div className={styles.getPremiumButton}>
                        <ButtonRound onClick={handleGetPremium} variant="outlined">
                            Premium freischalten
                        </ButtonRound>
                    </div>
                </div>
            ) : (
                <div className={styles.premiumContainer}>
                    <div className={styles.premiumBox}>
                        {ratings.map((rating, idx) => {
                            return (
                                <div key={idx}>
                                    {idx === activeRating && (
                                        <div className={styles.rating}>{rating}</div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    <div className={styles.premiumBox}>
                        <p className={styles.contactRequests}>{data.contactRequests !== null ? data.contactRequests : '??'}</p>
                        <p className={styles.text}>Anfragen bisher</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PropertyPremiumFeatures;
